export const sylndrDirections = 'https://goo.gl/maps/Pw9dHb1RG27w7bFQ9?coh=178573&entry=tt';
export const MOBILE_SCREEN_LABEL = 'Mobile';
export const DESKTOP_SCREEN_LABEL = 'Desktop';
